module.exports = __webpack_public_path__ + "static/media/xp-coins.68585bc2.svg";